import { observer } from "mobx-react-lite";
import * as React from "react";
import { DrawerPlmWithConfirmation } from "src/components/DrawerPlmWithConfirmation";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";

interface PropsMc2SelectSizeLineName {
  store: EntityFiltersPageStore | null;
  close: () => void;
  success: (selected: ZEntityRow) => void; // без закрывания
}

export const Mc2SelectSizeLineName: React.FC<PropsMc2SelectSizeLineName> =
  observer((props) => {
    const { store, close, success } = props;
    const tableStore = store?.tableStore;
    const selected = tableStore?.selected?.[0];
    return (
      <DrawerPlmWithConfirmation
        drawerProps={{
          title: "Изменение размерного ряда",
          open: !!store,
          onClose: close,
          width: "75vw",
        }}
        confirmationProps={{
          okText: "Выбрать",
          okButtonProps: {
            disabled: !selected,
            onClick: () => {
              if (selected) {
                success(selected);
                close();
              }
            },
          },
          cancelButtonProps: {
            onClick: close,
          },
        }}
      >
        {store && <EntityFiltersTable store={store} />}
      </DrawerPlmWithConfirmation>
    );
  });
